module.exports = __webpack_public_path__ + "static/media/assessment-footer-bg.7cd1f4cc.png";